import {useEffect} from 'react'

import {useReservationDetailsStorage} from '../storage'
import {useGetLayoutSize} from '../../../components-shared/LayoutSizeProvider'
import {getShouldShowAutoApproveText} from '../../../utils/getShouldShowAutoApproveText'
import {RequestStatus} from '../../../utils/wrapRequest'

export const useHooks = () => {
  const {
    reservation,
    isManualApproval,
    getCurrentMember,
    currentMember,
    approvalTextEditorState,
    breadcrumbsConfig,
    reservationDataQueryParams,
    getExperienceStatus,
  } = useReservationDetailsStorage()
  const {layoutSize} = useGetLayoutSize()

  useEffect(() => {
    getCurrentMember()
  }, [getCurrentMember])

  const shouldShowAutoApproveText = getShouldShowAutoApproveText(
    approvalTextEditorState,
    isManualApproval,
  )

  const isExperienceLoading =
    !!reservationDataQueryParams?.experienceIdQueryParam &&
    getExperienceStatus !== RequestStatus.RESOLVED &&
    getExperienceStatus !== RequestStatus.FAILED

  return {
    reservation,
    isManualApproval,
    layoutSize,
    currentMember,
    shouldShowAutoApproveText,
    breadcrumbsConfig,
    isExperienceLoading,
  }
}
